import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.dashboard');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-farm-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.dashboard/view.scss */
/* src/app/portal.farm.dashboard/view.scss: no such file or directory */`],
})
export class PortalFarmDashboardComponent implements OnInit, OnChanges {

    @Input() farm_id: string = '';

    @Input() farm!: any;

    constructor(@Inject( Service    )         public service: Service    ) {}

    private inited = false;

    public data = [];

    public map = {
        grade: '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',')
    };

    public machineCount: number | null = null;
    public totalQuantity: number | null = null;
    public totalWeight: number | null = null;
    public totalPlate: number | null = null;

    public async ngOnInit() {

        await this.service.init();
        this.inited = true;

        if (this.farm_id) {
            await this.loadStatistic();
        }

        await this.service.render();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        const farmIdChanged = changes['farm_id'];
        if (!farmIdChanged) return;
        if (farmIdChanged.firstChange) return;
        if (!this.inited) return;
        if (!this.farm_id) return;

        await this.refresh();
    }

    public async refresh() {
        if (!this.farm_id) return;

        await this.loadStatistic();
        await this.service.render();
    }

    private async loadStatistic() {
        this.machineCount = null;
        this.totalQuantity = null;
        this.totalWeight = null;
        this.totalPlate = null;
        await this.service.render();

        try {
            const res = await wiz.call('statistic', { farm_id: this.farm_id });

            if (res?.code !== 200 || !res.data) return false;

            const data = res.data;

            this.data = (data.log ?? []).filter(
                (item) => item && typeof item.grade === 'number'
            );

            this.machineCount = data.machines ?? 0;

            let quantity = 0;
            let weight = 0;
            let plate = 0;

            for (const item of this.data) {
                quantity += item.quantity || 0;
                weight += item.weight || 0;
                plate += item.plate || 0;
            }

            this.totalQuantity = quantity;
            this.totalWeight = weight;
            this.totalPlate = plate;

            return true;

        } catch (e) {
            console.error('statistic API error:', e);
            return false;
        } finally {
            await this.service.render();
        }
    }
}

export default PortalFarmDashboardComponent;